/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// librares
import { connect } from 'react-redux';
// actions
import { displayMessage } from '@insticator/insticator-ui'; // iui-state
import { getDetailRevenueMetrics, updateDetailDateRange } from 'state/actions/detailViewState/detailViewStatus';
import { updataDetailDropDown, fetchRONSites, fetchCountries, clearDetailState } from 'state/actions/detailViewState/detailViewStatus';
// component
import Impressions from 'pages/dashboard/analytics/detail/metrics/impressions/impressions';



/* ========== ~~~~~~~~~~ DATA IMPRESSIONS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ detailViewStatus, homeState, sessionStatus, accountData }) => {
    const { homeAnalyticsStatus } = homeState;
    return {
        devices: detailViewStatus.devices,
        selectedDevices: detailViewStatus.selectedDevices,
        countries: detailViewStatus.countries,
        countriesReceived: detailViewStatus.countriesReceived,
        selectedCountries: detailViewStatus.selectedCountries,
        sites: accountData.sites,
        sitesReceived: accountData.sitesReceived,
        ronSitesReceived: detailViewStatus.ronSitesReceived,
        ronSites: detailViewStatus.ronSites,
        selectedSites: detailViewStatus.selectedSites,
        selectedRevenueType: homeAnalyticsStatus.selectedRevenueType,
        dateRange: detailViewStatus.dateRange,

        impressionDetail: detailViewStatus.impressionDetail,
        fetchingRevenue: detailViewStatus.fetchingRevenue,

        accountUUID: sessionStatus.accountUUID
    }};

// map actions
const mapDispatchToProps = dispatch => ({
    displayMessage: message => dispatch(displayMessage(message)),
    updateDateRange: range => dispatch(updateDetailDateRange(range)),
    updateDetailDropDown: (items, itemType) => dispatch(updataDetailDropDown(items, itemType)),
    fetchCountries: (accountUUID, paramString) => dispatch(fetchCountries(accountUUID, paramString)),
    fetchRONSites: (accountUUID, paramString) => dispatch(fetchRONSites(accountUUID, paramString)),
    getDetailRevenueMetrics: (paramString, dataType) => dispatch(getDetailRevenueMetrics(paramString, dataType)),
    clearDetailState: () => dispatch(clearDetailState())
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Impressions);
